import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import {
	Card,
	CardBody,
	CardHeader,
} from "@tql/ui-components-react/kendo/layout";
import { Button } from "@tql/ui-components-react/tql/buttons";
import {
	alertTriangle,
	bookOpen_01,
	infoCircle,
} from "@tql/ui-components-react/untitled/icons";
import { useState } from "react";

import type { ShipmentCarrierService } from "~/shared/schemas/shipment-management-schema";
import { getBaseUrl } from "~/shared/utils/get-base-url.ts";

import { CARRIER_SERVICE_DEFAULT } from "../../utils/defaults.ts";
import { TerminalModal } from "../terminal-modal/index.tsx";

export const CarrierService = ({
	details = CARRIER_SERVICE_DEFAULT,
	shipmentDate = "",
}: {
	details?: ShipmentCarrierService;
	shipmentDate?: string;
}) => {
	const [isTerminalModalOpen, setIsTerminalModalOpen] = useState(false);
	const baseUrl = getBaseUrl();
	const transitDays = details.transitTime ?? 0;
	return (
		<div
			className={"card-wrapper"}
			data-testid={"shipment-management-carrier-service"}
		>
			<Card className={"shipment-info-card"}>
				<CardHeader>
					<h3>Carrier Service</h3>
				</CardHeader>
				<CardBody>
					<div className={"carrier-service-details"}>
						<div className={"info-field"}>
							<div className={"section-label"}>Service Level</div>
							<div data-testid={"carrier-service-level"}>
								{details.serviceLevel}
							</div>
						</div>
						<div className={"info-field"}>
							<div className={"section-label info-label-with-icon"}>
								Service Type
								<span title={"this is the tooltip"}>
									<SvgIcon icon={infoCircle} themeColor={"primary"} />
								</span>
							</div>
							<div data-testid={"carrier-service-type"}>
								{details.serviceType}
							</div>
						</div>
						<div className={"info-field"}>
							<div className={"section-label"}>Transit Days</div>
							<div data-testid={"carrier-service-transit-time"}>
								{transitDays} {transitDays === 1 ? "Day" : "Days"}
							</div>
						</div>
						<div className={"info-field"}>
							<div className={"section-label"}>Max Liability (New / Used)</div>
							<div
								className={"carrier-service-liability"}
								data-testid={"carrier-service-liability"}
							>
								{details.liabilityPerPound}
							</div>
						</div>
						<div className={"carrier-service-links"}>
							<Button
								onClick={() => setIsTerminalModalOpen(true)}
								startIcon={<SvgIcon icon={bookOpen_01} />}
								variant={"tertiary"}
							>
								Pickup / Delivery Terminals
							</Button>
							<Button
								onClick={() =>
									window.open(
										`${baseUrl}/documents/carrier-restrictions/ProhibitedCommodities_${details?.scac}.pdf`,
										"_blank",
										"noopener,noreferrer",
									)
								}
								startIcon={<SvgIcon icon={alertTriangle} />}
								variant={"tertiary"}
							>
								Carrier Restrictions
							</Button>
						</div>
					</div>
				</CardBody>
			</Card>
			<TerminalModal
				details={details}
				isOpen={isTerminalModalOpen}
				onClose={() => {
					setIsTerminalModalOpen(false);
				}}
				shipmentDate={shipmentDate}
			/>
		</div>
	);
};
